import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Container, Theme } from '@material-ui/core';
import { DesktopBackground } from '../../../../components/atoms/DesktopBackground';
import Footer from '../../../../components/Footer';
import IdentificationErrorPanel from './IdentificationErrorPanel';

const useStyles = makeStyles((theme: Theme) => ({
  cancelHeader: {
    backgroundColor: 'var(--color-key)',
    padding: '20px 16px 24px',
    '@media (min-width:768px)': {
      borderRadius: '10px 10px 0 0'
    }
  },
  heading: {
    margin: 0,
    paddingTop: 20,
    color: 'var(--color-white)',
    fontSize: 16,
    letterSpacing: '0.08em',
    fontWeight: 'bold',
    textAlign: 'center'
  },
  contents: {
    '@media (max-width:767px)': {
      minHeight: 'calc(100vh - 296px)'
    }
  },
  container: {
    textAlign: 'left',
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#E0E0E0'
    },
    '& .Mui-focused': {
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: 'var(--color-key)'
      }
    }
  },
  footer: {
    marginTop: theme.spacing(4)
  }
}));

const CanceledScreen: React.FC<{}> = () => {
  const classes = useStyles({});

  return (
    <DesktopBackground>
      <div className={classes.cancelHeader}>
        <h1 className={classes.heading}>{'スマモル賃貸サービスお申し込み'}</h1>
      </div>
      <div className={classes.contents}>
        <Container className={classes.container}>
          <IdentificationErrorPanel kind={'canceled'} />
        </Container>
      </div>
      <div className={classes.footer}>
        <Footer />
      </div>
    </DesktopBackground>
  );
};

export default CanceledScreen;
